import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { X, Loader2, ShieldCheck } from "lucide-react";
import { NavBar } from "../components/NavBar";
import { resetPassword } from "../lib/api";

export default function ResetPassword() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    if (submitting) return;
    setError(null);
    if (password.length < 6) {
      setError("Password must be at least 6 characters.");
      return;
    }
    if (password !== confirm) {
      setError("Passwords don't match.");
      return;
    }
    setSubmitting(true);
    try {
      await resetPassword(token, password);
      toast.success("Password reset — please sign in");
      navigate("/sign-in");
    } catch (err) {
      setError(err?.message || "This reset link is invalid or has expired.");
      setSubmitting(false);
    }
  };

  return (
    <>
      <NavBar />
      <main className="container-nc" style={{ paddingTop: 36, paddingBottom: 90, maxWidth: 460 }}>
        <button className="btn-icon" onClick={() => navigate("/sign-in")} data-testid="reset-close" style={{ marginBottom: 24 }}>
          <X size={18} />
        </button>
        <span className="chip chip-brand"><ShieldCheck size={13} /> Set new password</span>
        <h1 style={{ fontSize: "clamp(1.9rem, 5vw, 2.5rem)", fontWeight: 600, letterSpacing: "-0.03em", lineHeight: 1.1, margin: "18px 0 10px" }}>
          Choose a new password
        </h1>

        {!token ? (
          <div className="card card-pad" data-testid="reset-invalid">
            <p style={{ color: "var(--muted)", lineHeight: 1.6, margin: 0 }}>
              This reset link is missing or invalid. Please request a new one.
            </p>
            <button className="btn btn-primary btn-lg" style={{ marginTop: 18 }} onClick={() => navigate("/forgot-password")}>
              Request new link
            </button>
          </div>
        ) : (
          <form onSubmit={submit} className="card card-pad" style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            <div>
              <label className="label">New password</label>
              <input className="input" type="password" required minLength={6} placeholder="At least 6 characters" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="reset-password" autoComplete="new-password" />
            </div>
            <div>
              <label className="label">Confirm password</label>
              <input className="input" type="password" required placeholder="Re-enter password" value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="reset-confirm" autoComplete="new-password" />
            </div>
            {error && <p style={{ color: "var(--brand)", fontSize: 13, margin: 0 }} data-testid="reset-error">{error}</p>}
            <button type="submit" className="btn btn-primary btn-lg btn-block" disabled={submitting} data-testid="reset-submit">
              {submitting ? <Loader2 size={18} className="spin" /> : "Reset password"}
            </button>
          </form>
        )}
      </main>
    </>
  );
}
